.cv{display:inline-flex;}